import { render, staticRenderFns } from "./ServiceContainer.vue?vue&type=template&id=d183faa2"
import script from "./ServiceContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceContainer.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports